import {Component, Input, OnInit} from '@angular/core';
import {Configuration} from '@shared/models/configuration';

@Component({
    standalone: false,
    selector: 'particle-comapany-tickets',
  templateUrl: './comapany-tickets.component.html',
  styleUrls: ['./comapany-tickets.component.scss']
})
export class ComapanyTicketsComponent implements OnInit {

  @Input() ticketId: string;
  @Input() data:any;
  @Input() board:any;
  sourceKey = 'RelevantTickets';

  constructor() { }

  ngOnInit() {
    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['TICKET_ID'] = this.ticketId;
    Configuration.setSmartGridConfig(this.sourceKey, config);
  }

  onGridCellValueChange ($event) {
    this.navigate($event.item.cells.Title.value);
  }

  navigate (card: any) {
    const result = {
      action: 'Redirect',
      board : this.board,
      card  : card
    };
    const dialogRef = this.data['dialogRef'];
    dialogRef.close(result);
  }

}
